<template>
    <nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-dark" aria-label="Main navigation">
        <div class="container-fluid p-sm-2">
            <a class="navbar-brand" href="/">
                <img
                    src="/assets/images/favicon.png"
                    style="width: 40px"
                    class="me-1"
                />
                {{ G.systemData?.title?.value }}
            </a>
            <button
                class="navbar-toggler p-0 border-0"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                    <li class="nav-item" v-for="(item, index) in menu" :key="index">
                        <a class="nav-link text-uppercase" :href="item.link != '' ? item.link : '#'">{{ item.translate[0].name }}</a>
                    </li>
                </ul>

                <div class="px-3 text-light">|</div>

                <ul class="navbar-nav">
                    <li class="nav-item" v-for="(item, index) in links" :key="index">
                        <a :href="item.link" class="nav-link" target="_blank">
                            <i :class="item.icon"></i>
                        </a>
                    </li>
                </ul>
            </div>

            <div v-if="langs.length > 1" class="navbar-nav dropdown text-end1 mb-3 mb-lg-0 ms-sm-3">
                <a href="#" class="dropdown-toggle lang-flag text-light" data-bs-toggle="dropdown" aria-expanded="false">
                    <!-- {{ $route.params.lang !== undefined ? langs.filter(e => e.shortname == $route.params.lang)[0]?.flag : '' }} -->
                    <img :src="`/assets/images/flags/${$route.params.lang}.png`" style="width: 24px;" />
                    {{ $route.params.lang !== undefined ? $route.params.lang : '' }}
                </a>
                <ul class="dropdown-menu" style="">
                    <li class="nav-item" v-for="(l, lind) in langs" :key="lind">
                        <a class="nav-link ps-3 cursor-pointer lang-flag text-secondary" @click="changeLang(l.shortname)">
                            <img :src="`/assets/images/flags/${l.shortname}.png`" style="width: 24px;" />
                            {{ l.shortname }}
                        </a>
                        <!-- <a class="nav-link ps-3 cursor-pointer" @click="changeLang(l.shortname)">{{ l.flag }} {{ l.shortname }}</a> -->
                    </li>
                </ul>
            </div>

        </div>
    </nav>
</template>


<script>
    import { useRoute } from "vue-router";

    import { data as data1 } from "@/data/data";
    import { G } from "@/_common";

    export default {
        name: "HeaderC",
        props: ["menu", "links", "langs"],
        setup() {
            const route = useRoute();

            const changeLang = (lang) => {
                // const result = text.replace(/B/g, match => ++t === 2 ? 'Z' : match)
                // window.location.href = '//' + window.location.host + '' + route.path.replace(/^\/([a-z]{2})(\/)?/, `/${lang}$2`);
                window.location.href = route.path.replace(/^\/([a-z]{1,3})(\/)?/, `/${lang}$2`);
            };

            return {
                G,
                data1,
                changeLang,
            };
        },
    };
</script>


<style lang="scss">
    .navbar > .container-fluid {
        margin: 0px 140px;
    }

    .nav-item a {
        font-size: 12pt;
        font-weight: 900;
        // color: #ffffff !important;
    }

    @media (max-width: 576px) {
        .navbar > .container-fluid {
            margin: unset;
        }
    }
</style>